<!DOCTYPE html>
<div class="card-wrapper">
  <ion-card class="blue-bg">
    <ion-card-header class="emo-wrapper">
      <h4><img alt="sad-emo-image" src="../../../assets/images/sademo.png"> </h4>
    </ion-card-header>
    <ion-card-content class="data-wrapper">
      <div>
        You are not currently being charged for this syndicate. Are you sure you want to stop?
      </div>
      <ion-button class="purple-btn" (click)="confirmLeaveReason()">Stop syndicate</ion-button>
      <p class="sub-link" (click)="close()">I've changed my mind</p>
    </ion-card-content>
  </ion-card>
</div>
